// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1OND5","additionalInfo":"AgreementModal_additionalInfo__e3nhu"};